(() => {
    document.querySelectorAll('[data-quiz-energy]').forEach(root => {
        const appId = root.dataset.interactAppId;
        const embedWidth = root.dataset.embedWidth || '800';
        const embedHeight = root.dataset.embedHeight || '800';
        const overlay = root.querySelector('[data-quiz-modal-overlay]');
        const openBtns = root.querySelectorAll('[data-quiz-open]');
        const closeBtns = root.querySelectorAll('[data-quiz-close]');
        let scriptLoaded = false;
        let scriptLoading = false;

        const openQuiz = () => {
            overlay.classList.add('open');
            overlay.setAttribute('aria-hidden', 'false');
            document.body.classList.add('quiz-modal-lock');

            if (!scriptLoaded && !scriptLoading) {
                scriptLoading = true;
                const s = document.createElement('script');
                const options = {
                    appId: appId,
                    width: embedWidth,
                    height: embedHeight,
                    async: true,
                    host: 'quiz.tryinteract.com',
                    mobile: true,
                    redirect_host: true
                };
                s.src = 'https://i.tryinteract.com/embed/app.js';
                s.onload = s.onreadystatechange = function () {
                    const rs = this.readyState;
                    if (rs && rs !== 'complete' && rs !== 'loaded') return;
                    scriptLoaded = true;
                    scriptLoading = false;
                    try {
                        const app = new window.InteractApp();
                        app.initialize(options);
                        app.display();
                    } catch (e) {}
                };
                const firstScript = document.getElementsByTagName('script')[0];
                firstScript.parentNode.insertBefore(s, firstScript);
            }
        };

        const closeQuiz = () => {
            overlay.classList.remove('open');
            overlay.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('quiz-modal-lock');
        };

        openBtns.forEach(btn => btn.addEventListener('click', openQuiz));
        closeBtns.forEach(btn => btn.addEventListener('click', closeQuiz));

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeQuiz();
        });

        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) closeQuiz();
        });
    });
})();
